import { mask } from 'remask';

export function maskCnpj(value: string | undefined) {
  if (!value) return '';
  const cep = ['99.999.999/9999-99'];

  return mask(value, cep);
}
